import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import ReactDOMServer from 'react-dom/server';

import DropzoneReact from './dropzone-react/dropzone-react.jsx';
import DropzoneUploadOverlay from './drop-here/dropzone-upload-overlay.jsx';
import {StorageProvider as StorgageProvider} from "../../../gd/const/storage";
import Attachment from "../../../model2/attachment/attachment";

// const debug = "DropzoneNew"
const debug = false

// by vic feb 20021
export default class DropzoneNew extends React.Component {

    static propTypes = {
        dzId: PropTypes.string.isRequired,
        djsContainer: PropTypes.string.isRequired,
        onProcessing: PropTypes.func,
        onUploadProgress: PropTypes.func,
        onChange: PropTypes.func,
        hiddenInputContainer: PropTypes.any,
        name: PropTypes.string.isRequired,
        label: PropTypes.string,
        mode: PropTypes.string,
        onlySingleFile: PropTypes.bool,

        onAddToMessage: PropTypes.func,

        attachmentsManager: PropTypes.object.isRequired    // AttachmentsManager object
    };

    static defaultProps = {
        label: 'Attach file(s)'
    };

    constructor(props) {
        super(props);

        this.storageProvider    = gd.company.settings.storage.provider
        this.isS3Upload         = StorgageProvider.isS3Upload(this.storageProvider)
        this.isLocalUpload      = StorgageProvider.isLocalUpload(this.storageProvider)

        this.dropOverlayNodeId = null;
        this.dragCollection = $();
        this.dropOverlayClassName = 'djs-tip';

        // this.pastedFiles = [];

        this.state = {
            files: [],
            dropzoneComponent: null
        };

        this.dropOverlayNodeId = "dz-overlay-" + this.props.dzId;
    }

    componentDidMount () {
        const node = document.createElement('div');
        node.innerHTML = ReactDOMServer.renderToStaticMarkup(
            <DropzoneUploadOverlay className={this.dropOverlayClassName} nodeId={this.dropOverlayNodeId}/>
        );
        const overlayNode = node.firstChild;

        $(this.props.djsContainer).append(overlayNode); // new
        //document.querySelector(this.props.djsContainer).appendChild(overlayNode); - Old

        gd.bus.subscribe("dropzone:disable", this, this.disableDropzone);
        gd.bus.subscribe("dropzone:enable", this, this.enableDropzone);
    }

    componentWillUnmount() {
        this.dropOverlayDestroy();
        gd.bus.unsubscribe(this);
    }

    disableDropzone = () => {if (this.dropzoneComponent) this.dropzoneComponent.disable();}
    enableDropzone = () => {if (this.dropzoneComponent) this.dropzoneComponent.enable();}

    getFiles = () => {return this.state.files;}

    onFileAdded = () => {}

    removeFile = (fileId) => {

        debug && console.log(debug, "removeFile()", fileId)

        const file = _.find(this.state.files, f=>f.clientFile.fileId === fileId);
        this.dropzoneComponent.removeFile(fileId, file ? file.clientFile : null);
    }

    onFileRemove = (removedFile) => {

        debug && console.log("onFileRemove", removedFile)

        _.forEach(this.state.files, (obj, key)=>{
            if (obj && obj.clientFile === removedFile) {
                this.state.files.splice(key, 1);
            }
        });

        if (this.props.onChange) this.props.onChange()

        this.setState({
            files: this.state.files
        });
    }

    onUploadComplete = () => {/*console.log("Done. All uploads completed.");*/}

    onFilesUploaded = (arrFiles, arrResult) => {
    }

    click = () => {
        this.state.dropzoneComponent.hiddenFileInput.click();
    }

    resetFiles = () => {
        this.dropzoneComponent.removeAllFiles(true);

        this.setState({
            files: []
        });
    }

    initCallback = (dropzone) => {
        this.setState({
            dropzoneComponent: dropzone
        });
    }

    dropOverlayDestroy = () => {$('#'+this.dropOverlayNodeId).remove();}
    dropOverlayShow = () => {$('#'+this.dropOverlayNodeId).show();}
    dropOverlayHide = () => {$('#'+this.dropOverlayNodeId).hide();}
    onDragStart = (e) => {/*console.log("Dropzone onDragStart");*/}
    onDragEnd = (e) => {/*console.log("Dropzone onDragEnd");*/}
    onDragOver = (e) => {/*console.log("Dropzone onDragOver");*/}

    onDragEnter = (e) => {
        //if dragged data is not file
        if (!this.isFileDragged(e.dataTransfer.types)) return false;

        e.preventDefault();
        e.stopPropagation();

        let el = document.querySelector(this.props.djsContainer);
        el.classList.add("add-blur");

        setTimeout(()=>{
            if (this.dragCollection.length === 0) {
                //$('#'+this.dropOverlayNodeId).show();
                this.dropOverlayShow();
            }
            this.dragCollection = this.dragCollection.add(e.target);
            //console.log("Dropzone onDragEnter", this.dragCollection.length, this.dragCollection);
        }, 10);

        return false;
    }

    onDragLeave = (e) => {
        //if dragged data is not file
        if (!this.isFileDragged(e.dataTransfer.types)) return false;

        e.preventDefault();
        e.stopPropagation();

        let el = document.querySelector(this.props.djsContainer);
        el.classList.remove("add-blur");

        setTimeout(()=>{
            if (e.target.id === "tip-overlay-id") this.dragCollection = $();
            else this.dragCollection = this.dragCollection.not(e.target);

            if (this.dragCollection.length === 0) this.dropOverlayHide();
        }, 10);

        return false;
    }

    onDrop = (e) => {
        this.dragCollection = $();
        this.dropOverlayHide();

        //if dragged data is not file
        if (!this.isFileDragged(e.dataTransfer.types)) return false;

        e.preventDefault();
        e.stopPropagation();

        return false;
    }

    isFileDragged = (types) => {
        return typeof types.contains === 'function' ? types.contains("Files") : types.indexOf("Files") !== -1
    }

    onProcessing = (file) => {
        if (this.props.onProcessing) this.props.onProcessing(file);
    }

    onUploadProgress = (file, percent, bytes) => {
        // console.log("... progress", percent, "trigger:", file.attachment.fileId+"-progress")
        gd.bus.triggerEvent(file.attachment.fileId+"-progress",{percent: percent})
    }

    pasteImage = (file) => {
        debug && console.log(debug, ".pasteImage()", file)
        if (this.dropzoneComponent) {
            // this.pastedFiles.push(file);
            this.dropzoneComponent.pasteImage(file);
        }
    }

    updateHiddenAttachments = (hiddenAttachments) => {
        const { previewsContainer } = this.dropzoneComponent.dropzone;

        _.map(previewsContainer.childNodes, cn=> {
            const fileId = cn.getAttribute('fileId');
            if (hiddenAttachments.includes(fileId)) cn.classList.add("dz-preview-hidden");
            else                                    cn.classList.remove("dz-preview-hidden");
        })
    }

    // onAddToMessageClick = (file, response) => {
    //     if(this.props.onAddToMessage) {
    //         file.previewTemplate.classList.add("dz-preview-hidden");
    //
    //         switch (response.fileType) {
    //             case gd.const.attachment.fileType.IMAGE:
    //             case gd.const.attachment.fileType.GRAPHIC_SOURCE:
    //                 const url = gd.api.Attachment.previewUploadsUrl(response.fileId, response.preview); //"https://www.lokeshdhakar.com/projects/lightbox2/images/image-3.jpg";
    //                 /*gd.utils.getImageDimensions(url, (width, height)=>{
    //                     const aspectRatio = height/width;
    //                     this.props.onAddToMessage(_.assign({}, response, file, {url, aspectRatio}));
    //                 });*/
    //                 const aspectRatio = 76/108; //according to css
    //                 this.props.onAddToMessage(_.assign({}, file, response, {url, aspectRatio}));
    //                 break;
    //
    //             default:
    //                 this.props.onAddToMessage(_.assign({}, file, response));
    //                 break;
    //         }
    //     }
    // }

    getConfig = () => {

        const config = {


            url                     : gd.api.Attachment.uploadUrl(), // main upload uri

            clickable               : '.filepicker.dropzone.clickable-' + this.props.dzId,

            hiddenInputContainer    : this.props.hiddenInputContainer,
            paramName               : this.props.name,

            parallelUploads         : 5,
            uploadMultiple          : false, // SUPER IMPORTANT otherwiese will send to same URL (!!!!)
            autoQueue               : true, // experimental to do one by oen ? enable to work with max parralel uploads (!)

            maxFilesize             : gd.company.license.maxAttachmentMb, //Mb
            maxFiles                : this.props.onlySingleFile ? 1 : 20, // if not null defines how many files this Dropzone handles.

            // THUMBNAILS
            createImageThumbnails   : false,
            maxThumbnailFilesize    : 1, // in MB. When the filename exceeds this limit, the thumbnail will not be generated.
            thumbnailWidth          : null, // if null, the ratio of the image will be used to calculate it.
            thumbnailHeight         : 100, // the same as thumbnailWidth. If both are null, images will not be resized.

            //paramName: 'file',

            addRemoveLinks          : false, // i guess we do it custom in preview tpl
            previewsContainer       : '#dz-preview-' + this.props.dzId,

            // previewTemplate         : DropzonePreview,

            // ahhh important
            // The timeout for the XHR requests in milliseconds (since v4.4.0). If set to null or 0, no timeout is going to be set.
            timeout                 : 1000 * 60 * 10

        };


        if (this.isS3Upload) {
            // only put supported by lambda upload...
            config.method = "PUT"
        }


        if (this.isS3Upload || this.isLocalUpload) {

            config.accept = (file, done) => {
                // console.log("--accept - generate lambda upload url")

                const newAttachment = Attachment.initForNewUpload(file)
                file.attachment = newAttachment

                this.props.attachmentsManager.onFileUploadStart(newAttachment)

                if (this.isLocalUpload) {
                    done()
                    return
                }


                // !!!! encodeURIComponent - seems like super important with crazy filenames ?
                // fetch(StorgageProvider.generateUploadUrl(this.storageProvider),{
                fetch(StorgageProvider[this.storageProvider].generateUploadUrl,{
                    method: "POST",
                    body: JSON.stringify({
                        fileId              : newAttachment.fileId,
                        storageProvider     : newAttachment.storageProvider,
                        fileName            : '',//encodeURIComponent(newAttachment.name),
                        companyId           : gd.companyId
                    })
                })
                    .then(requestPromise=>{

                        return requestPromise.json()

                    })
                    .then(response=>{
                        // console.log("Lambda generate upload url repsonse", response)
                        const uploadUrl = response.uploadUrl
                        // console.log("uploadUrl FROM RESPONSE=", uploadUrl)
                        file._uploadUrl = uploadUrl
                        // file.attachment._uploadUrl = uploadUrl
                        done()
                    })
            }

            config.success = (file, response) => {
                // console.log("    success")

                if (this.isLocalUpload) {

                    // tut vse ploho....
                    file.attachment.fileId = response[0].fileId
                    gd.bus.triggerEvent(file.attachment.fileId+"-upload-done")
                    this.props.attachmentsManager.onFileUploadDone(file.attachment);
                    return
                }

                if (file.attachment.canGenerateThumbnail) {

                    // custom status (!)
                    file.status = 'generating-thumbnail'
                    gd.bus.triggerEvent(file.attachment.fileId+"-generating-thumbnail")

                    fetch(StorgageProvider.generateThumbnailsUrl(this.storageProvider),{
                        method: "POST",
                        body: JSON.stringify({
                            fileId              : file.attachment.fileId,
                            storageProvider     : file.attachment.storageProvider,
                        })
                    })
                    .then(requestPromise=>{
                        return requestPromise.json()
                    })
                    .then(response=>{
                        // console.red("Lambda generate thumbnails repsonse")
                        // console.log(response)

                        if (response.generateThumbnails === true) {
                            // we generated thymbnails...
                            file.attachment.preview = gd.const.attachment.preview.AVAILABLE
                        } else {
                            file.attachment.preview = gd.const.attachment.preview.NOT_AVAILABLE
                        }

                        // bring back original status
                        file.status = 'success'


                        gd.bus.triggerEvent(file.attachment.fileId+"-upload-done")
                        this.props.attachmentsManager.onFileUploadDone(file.attachment);
                    })



                } else {
                    // console.log("NO THUMBNAIL GENERATION NEEDED")

                    gd.bus.triggerEvent(file.attachment.fileId+"-upload-done")

                    // collection changed... tipo + 1 file ?
                    this.props.attachmentsManager.onFileUploadDone(file.attachment);
                }
            }

            config.sending = (file, xhr) => {

                if (this.isLocalUpload) return

                // console.log("dz sending called")

                var _send = xhr.send;
                xhr.setRequestHeader('x-amz-acl', 'public-read');
                xhr.send = function() {
                    // xhr.requestUrl - custom in custom dropzone.js (!)
                    // console.log("xhr.requestUrl=", xhr.requestUrl)
                    // console.log("_uploadUrl=", file.attachment._uploadUrl)
                    _send.call(xhr, file);
                }

            }

            config.processing = (file) => {
                // console.log("-- processing", file.attachment.fileId, file.signedRequest)

                if (this.isLocalUpload) return

                this.dropzoneComponent.dropzone.options.url = file._uploadUrl;
            }

        }

        return config


    }

    render() {

        const djsConfig = this.getConfig()

        const eventHandlers = {
            init: this.initCallback,

            // All of these receive the event as first parameter:
            drop: this.onDrop,
            dragstart:  this.onDragStart,
            dragend: this.onDragEnd,
            dragenter: this.onDragEnter,
            gragover: this.onDragOver,
            dragleave: this.onDragLeave,
            // All of these receive the file as first parameter:
            addedfile: this.onFileAdded,
            removedfile: this.onFileRemove,
            thumbnail: null,
            error: (file, message) => {
                if (this.dropzoneComponent) {
                    const { filesizeBase } = this.dropzoneComponent.dropzone.options;
                    const size = gd.utils.Convert.fileSize(file.size,filesizeBase);
                    const sizeMb = file.size/Math.pow(filesizeBase, 2);
                    if (sizeMb > djsConfig.maxFilesize) {
                        gd.growl.error("File \"" + file.upload.filename + "\" (" + size +") exceeds max upload file size of " + djsConfig.maxFilesize + " Mb");
                    }
                }
            },
            processing: this.onProcessing,
            uploadprogress: this.onUploadProgress,
            sending: null,
            success: null,
            complete: () => {
                // console.log("Dropzone complete", arguments);
            },
            canceled: () => {
                // console.log("Dropzone canceled", arguments);
            },
            maxfilesreached: null,
            maxfilesexceeded: null,

            // All of these receive a list of files as first parameter
            // and are only called if the uploadMultiple option
            // in djsConfig is true:
            processingmultiple: null,
            sendingmultiple: null,

            successmultiple: this.onFilesUploaded,
            completemultiple: this.onUploadComplete,

            canceledmultiple: null,
            // Special Events
            totaluploadprogress: null,
            reset: null,
            queuecompleted: null
        };

        const classes = Classes('gd-dz', this.props.className);

        return (
            <div className={classes}>
                <DropzoneReact ref           = {r=> {this.dropzoneComponent = r}}
                               eventHandlers = {eventHandlers}
                               djsConfig     = {this.getConfig()}
                               djsContainer  = {this.props.djsContainer}
                               className     = {'clickable-' + this.props.dzId} >

                    {/*<div className="i5-attachment" />*/}
                    {/*<div className="default-label">{this.props.label}</div>*/}
                </DropzoneReact>

                <div className="gd-dz-uploaded dropzone" id={'dz-preview-' + this.props.dzId} />
            </div>
        );
    }
}
